import React, { useState, useEffect } from 'react';
import './App.css';
import AdminPanel from './components/AdminPanel/AdminPanel';
import iconScienceCamp from './assets/images/icons/Science Camp.png';
import iconTopMentors from './assets/images/icons/Top Mentors.png';
import iconAllInOnePrep from './assets/images/icons/All-In-One Prep.png';
import iconOneCrScholarships from './assets/images/icons/1 Cr Scholarships.png';

// Section 3 icons
import iconNothingToLose from './assets/images/icons/Nothing to Lose.png';
import iconRealOlympiadExposure from './assets/images/icons/Real Olympiad Exposure.png';
import iconConfidenceNotJustCoaching from './assets/images/icons/Confidence, Not Just Coaching.png';
import iconYourFirstBigMove from './assets/images/icons/Your First Big Move.png';

// Import images
import heroImage1 from './assets/images/hero/hero1.png';
import heroImage2 from './assets/images/hero/hero2.png';
import aboutImage from './assets/images/about/about-image.png';
import feature1Image from './assets/images/about/feature1.png';
import journeyBgImage from './assets/images/journey/journey-bg.png';
import newsImage from './assets/images/news/news.png';
import knowledgeBaseImage from './assets/images/backgrounds/knowledge-base.png';

const App = () => {
  // State for Knowledge Base menu selection
  const [selectedMenu, setSelectedMenu] = useState('About NatSciX');
  
  // Lightweight hash-based routing for blog detail
  const [activeRoute, setActiveRoute] = useState(null);

  // Helper to render blog content as plain text (no HTML)
  const toPlainText = (html) => {
    if (!html || typeof html !== 'string') return '';
    try {
      // Convert some common block tags to line breaks, then strip tags
      let text = html
        .replace(/<\s*br\s*\/?\s*>/gi, '\n')
        .replace(/<\s*\/(p|li|h[1-6])\s*>/gi, '\n')
        .replace(/<[^>]+>/g, '');
      // Decode minimal HTML entities we expect
      text = text
        .replace(/&nbsp;/g, ' ')
        .replace(/&amp;/g, '&')
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>');
      return text;
    } catch {
      return html;
    }
  };

  // Default blog posts data (seed)
  const defaultBlogPosts = [
    {
      id: 1,
      title: "2025 Scholarship Starter Guide: When, Where, and How to Apply",
      date: "June 6, 2016",
      category: "Admission, Student",
      excerpt: "Complete guide to applying for NatSciX scholarships in 2025. Learn about deadlines, requirements, and application process.",
      content: `
        <h3>Complete Guide to NatSciX Scholarships 2025</h3>
        <p>The National Science Excellence Exam (NatSciX) offers comprehensive scholarship opportunities for talented students across the country. This guide will walk you through everything you need to know about applying for scholarships in 2025.</p>
        
        <h4>Key Application Dates</h4>
        <ul>
          <li>Early Registration: January 15 - March 30, 2025</li>
          <li>Regular Registration: April 1 - May 15, 2025</li>
          <li>Late Registration: May 16 - June 30, 2025</li>
          <li>Exam Date: July 15, 2025</li>
        </ul>
        
        <h4>Scholarship Categories</h4>
        <p>We offer multiple scholarship tiers based on performance:</p>
        <ul>
          <li><strong>Gold Scholarship:</strong> 100% tuition coverage + living allowance</li>
          <li><strong>Silver Scholarship:</strong> 75% tuition coverage</li>
          <li><strong>Bronze Scholarship:</strong> 50% tuition coverage</li>
        </ul>
        
        <h4>How to Apply</h4>
        <p>Follow these simple steps to complete your application:</p>
        <ol>
          <li>Visit our official website at natscix.com/exam/</li>
          <li>Create your student account</li>
          <li>Fill out the application form</li>
          <li>Upload required documents</li>
          <li>Pay the registration fee</li>
          <li>Submit your application</li>
        </ol>
        
        <p>For more information, contact us at natscix@smis.edu.in</p>
      `,
      image: newsImage
    },
    {
      id: 2,
      title: "NatSciX Summer Camp 2025: Registration Now Open",
      date: "May 15, 2025",
      category: "Camp, Registration",
      excerpt: "Join our intensive summer science camp designed for exceptional students. Limited seats available.",
      content: `
        <h3>NatSciX Summer Camp 2025</h3>
        <p>We're excited to announce that registration is now open for our prestigious NatSciX Summer Camp 2025. This intensive program is designed for exceptional students who want to excel in science and mathematics.</p>
        
        <h4>Camp Highlights</h4>
        <ul>
          <li>Advanced laboratory sessions</li>
          <li>Interactive workshops with leading scientists</li>
          <li>Research project opportunities</li>
          <li>Peer collaboration and networking</li>
          <li>Certificate of completion</li>
        </ul>
        
        <h4>Program Details</h4>
        <p><strong>Duration:</strong> 4 weeks (July 1 - July 28, 2025)</p>
        <p><strong>Location:</strong> SMIS Campus, Bangalore</p>
        <p><strong>Age Group:</strong> 14-18 years</p>
        <p><strong>Capacity:</strong> Limited to 50 students</p>
        
        <h4>What's Included</h4>
        <ul>
          <li>Accommodation and meals</li>
          <li>All learning materials</li>
          <li>Laboratory access</li>
          <li>Field trips and excursions</li>
          <li>24/7 supervision and support</li>
        </ul>
        
        <p>Don't miss this opportunity to be part of an elite group of young scientists!</p>
      `,
      image: newsImage
    },
    {
      id: 3,
      title: "Success Stories: Meet Our 2024 Scholarship Winners",
      date: "April 20, 2025",
      category: "Success Stories, Students",
      excerpt: "Read inspiring stories from our 2024 scholarship recipients and their journey to success.",
      content: `
        <h3>Celebrating Our 2024 Success Stories</h3>
        <p>We're proud to share the inspiring journeys of our 2024 NatSciX scholarship winners. These exceptional students have shown remarkable dedication and achieved outstanding results.</p>
        
        <h4>Featured Success Stories</h4>
        
        <h5>Priya Sharma - Gold Scholarship Winner</h5>
        <p>"The NatSciX program completely transformed my approach to learning science. The mentorship and resources provided helped me secure admission to IIT Delhi with a full scholarship."</p>
        
        <h5>Arjun Patel - Silver Scholarship Winner</h5>
        <p>"The summer camp experience was life-changing. I learned advanced concepts that gave me a significant advantage in competitive exams. Now I'm studying at AIIMS New Delhi."</p>
        
        <h5>Sneha Reddy - Bronze Scholarship Winner</h5>
        <p>"NatSciX didn't just help me academically; it built my confidence and leadership skills. I'm now pursuing research in biotechnology at IISc Bangalore."</p>
        
        <h4>Key Achievements</h4>
        <ul>
          <li>95% of scholarship winners secured admission to top institutions</li>
          <li>Average improvement of 40% in competitive exam scores</li>
          <li>100% placement rate in desired career paths</li>
          <li>Strong alumni network supporting current students</li>
        </ul>
        
        <p>Join our community of achievers and write your own success story!</p>
      `,
      image: newsImage
    }
  ];

  // Blog posts state with localStorage persistence
  const [blogPosts, setBlogPosts] = useState(() => {
    try {
      const raw = localStorage.getItem('blogPosts');
      const parsed = raw ? JSON.parse(raw) : null;
      const base = Array.isArray(parsed) && parsed.length ? parsed : defaultBlogPosts;
      // Ensure content is plain text for all posts
      return base.map(p => ({ ...p, content: toPlainText(p.content) }));
    } catch (e) {
      return defaultBlogPosts.map(p => ({ ...p, content: toPlainText(p.content) }));
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem('blogPosts', JSON.stringify(blogPosts));
    } catch (_) {}
  }, [blogPosts]);

  // One-time migration: if stored posts contain HTML, sanitize and save back
  useEffect(() => {
    try {
      const raw = localStorage.getItem('blogPosts');
      if (!raw) return;
      const parsed = JSON.parse(raw);
      if (!Array.isArray(parsed)) return;
      let changed = false;
      const sanitized = parsed.map(p => {
        const plain = toPlainText(p.content);
        if (plain !== p.content) changed = true;
        return { ...p, content: plain };
      });
      if (changed) {
        localStorage.setItem('blogPosts', JSON.stringify(sanitized));
        setBlogPosts(sanitized);
      }
    } catch {}
  }, []);

  // Blog navigation helper

  // Navigate to blog detail page (hash route)
  const navigateToBlog = (post) => {
    if (!post) return;
    window.location.hash = `/blog/${post.id}`;
  };

  // Listen for hash changes to support blog detail routing
  useEffect(() => {
    const onHashChange = () => {
      const hash = window.location.hash || '';
      // Blog detail: supports #/blog/ID and #blog/ID
      const blogMatch = hash.match(/^#\/?blog\/(\d+)/);
      if (blogMatch && blogMatch[1]) {
        const id = Number(blogMatch[1]);
        setActiveRoute({ type: 'blog', id });
        return;
      }
      // Admin route: supports #/admin and #admin
      if (hash === '#/admin' || hash === '#admin') {
        setActiveRoute({ type: 'admin' });
        return;
      }
      setActiveRoute(null);
    };
    onHashChange();
    window.addEventListener('hashchange', onHashChange);
    return () => window.removeEventListener('hashchange', onHashChange);
  }, []);

  // Lock body scroll when admin overlay is open
  useEffect(() => {
    const isAdmin = activeRoute?.type === 'admin';
    const prev = document.body.style.overflow;
    if (isAdmin) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = prev || '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [activeRoute]);

  // No modal now; detail opens via hash route
  
  // Hero slider state
  const [currentHeroImage, setCurrentHeroImage] = useState(0);
  const heroImages = [heroImage1, heroImage2];
  
  // Auto-rotate hero images
  useEffect(() => {
    console.log('Hero images loaded:', heroImages.length);
    const interval = setInterval(() => {
      setCurrentHeroImage((prev) => {
        const nextIndex = (prev + 1) % heroImages.length;
        console.log('Switching to image index:', nextIndex);
        return nextIndex;
      });
    }, 4000); // Change image every 4 seconds
    
    return () => clearInterval(interval);
  }, [heroImages.length]);

  const menus = [
    {
      title: "About NatSciX",
      content: (
        <div>
          <h2 className="text-3xl font-bold mb-4">News & Updates</h2>
          <p className="text-lg mb-4">
            NatSciX is a national-level science excellence exam crafted to discover students who think deeply, solve creatively, and are ready to lead in science.
          </p>
          <p className="text-lg mb-4">
            Open to Grade 10 students from all boards — CBSE, ICSE, State, IGCSE, IB — the exam is designed not just to test knowledge, but to ignite purpose.
          </p>
          <p className="text-lg mb-4">
            Top-performing students receive up to ₹1 crore in scholarships, mentorship from IITians, doctors, and Olympiad faculty, and exclusive access to a fully sponsored residential science camp.
          </p>
          <p className="text-lg mb-4">
            And yes — it’s completely free to register and participate.
          </p>
        </div>
      ),
    },
    {
      title: "Prelims",
      content: (
        <div>
          <h2 className="text-3xl font-bold mb-4">This Is Your Entry Point</h2>
          <p className="text-lg mb-4">
            A 60-minute test that challenges not just what you know — but how you think. With 60 MCQs across science, math, logical reasoning, this round gives you a taste of Olympiad-level thinking in an accessible format.
          </p>
          <p className="text-lg mb-4">
            You can take it online individually, or offline through your school’s registration. Open to all boards — CBSE, ICSE, State, IGCSE, IB — anyone in Grade 10 can attempt.
          </p>
          <p className="text-lg mb-4">
            And yes, it’s completely free.
          </p>
        </div>
      ),
    },
    {
      title: "Qualifier",
      content: (
        <div>
          <h2 className="text-3xl font-bold mb-4">The Olympiad Edge</h2>
          <p className="text-lg mb-4">
            If you're among the Top 1000 in Prelims, you qualify for Round 2 — the real test of mindset, clarity, and courage.
          </p>
          <p className="text-lg mb-4">
            This round features challenging MCQs, closer to Olympiad-level thinking in science, math, and logic.
          </p>
          <p className="text-lg mb-4">
            It’s not about speed. It’s about depth and it’s your chance to prove you’re among the best.
          </p>
          <p className="text-lg mb-4">
            Only 80 make it through — into the fully sponsored Science Camp, held at St. Mary's ISC Campus, Chikmagalur.
          </p>
        </div>
      ),
    },
    {
      title: "Camp",
      content: (
        <div>
          <h2 className="text-3xl font-bold mb-4">The Week That Changes Everything</h2>
          <p className="text-lg mb-4">
            If you cross the cut-off in Round 2, you earn a spot among the Top 80 — and receive an invite to the fully sponsored 1-week residential science camp in St. Mary’s ISC Chikmagalur.
          </p>
          <p className="text-lg mb-4">
            At the camp, you’ll learn from IITians, doctors, and IISc faculty. You’ll explore advanced concepts, real-world science, and future possibilities.
          </p>
          <p className="text-lg mb-4">
            There’s more, evening reflections, team activities, and a prize distribution ceremony that marks a turning point in your journey.
          </p>
          <p className="text-lg mb-4">
            This isn’t just a reward. It’s the launchpad for your future.
          </p>
        </div>
      ),
    },
  ];

  // Blog Detail Page Render
  if (activeRoute?.type === 'blog') {
    const post = blogPosts.find(p => p.id === activeRoute.id);
    if (!post) {
      return (
        <div className="min-h-screen flex items-center justify-center">
          <div className="text-center">
            <p className="text-xl">Post not found.</p>
            <a href="#news" className="text-green-600 hover:text-green-800 underline">Back to News</a>
          </div>
        </div>
      );
    }
    return (
      <div className="min-h-screen bg-white text-black">
        {/* Simple blog header */}
        <header className="bg-navy text-white p-4 flex justify-between items-center">
          <a href="#news" className="text-green-300 hover:text-green-200">← Back to News</a>
          <span className="text-green-400 font-semibold">NatSciX</span>
        </header>

        <main className="container mx-auto px-4 py-10 max-w-3xl">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3">{post.title}</h1>
          <p className="text-sm text-gray-600 mb-6">{post.date} / {post.category}</p>
          <img src={post.image} alt={post.title} className="w-full h-64 md:h-96 object-cover rounded-lg mb-6" />
          <article className="prose prose-lg max-w-none">
            <div className="whitespace-pre-line text-gray-800">{toPlainText(post.content)}</div>
          </article>
        </main>
      </div>
    );
  }

  return (
    <div className="bg-white text-black">
      {/* Header */}
      <header className="bg-navy text-white p-4 flex justify-between items-center">
        <div className="flex items-center space-x-4">
          <span className="select-none font-alexandria font-extrabold text-white tracking-wide text-xl md:text-2xl lg:text-3xl">NatSciX</span>
        </div>
        <div className="flex items-center space-x-4">
          <span className="text-green-400 font-semibold">NatSciX</span>
          <nav className="hidden md:flex space-x-6">
            <a href="#home" className="hover:text-red-400 transition">Home</a>
            <a href="#about" className="hover:text-red-400 transition">About</a>
            <a href="#journey" className="hover:text-red-400 transition">Academics</a>
            <a href="#news" className="hover:text-red-400 transition">Blog</a>
            <a href="#knowledge-base" className="hover:text-red-400 transition">Choose Us</a>
          </nav>
          <a 
            href="https://natscix.com/exam/" 
            className="btn-global btn-sm"
          >
            Apply Now
          </a>
        </div>
      </header>

      {/* Section 1: Hero Slider */}
      <section id="home" className="relative h-screen overflow-hidden">
        {/* Rotating Background Images */}
        {heroImages.map((image, index) => (
          <div
            key={index}
            className={`absolute inset-0 transition-opacity duration-1000 ${
              index === currentHeroImage ? 'opacity-100' : 'opacity-0'
            }`}
            style={{
              backgroundImage: `url(${image})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              filter: 'brightness(0.6)'
            }}
          />
        ))}
        
        {/* Navigation Dots */}
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 flex space-x-2 z-20">
          {heroImages.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentHeroImage(index)}
              className={`w-3 h-3 rounded-full transition-colors ${
                index === currentHeroImage ? 'bg-white' : 'bg-white/50'
              }`}
            />
          ))}
        </div>
        
        <div className="relative z-10 flex flex-col items-start justify-center h-full text-white px-8 md:px-16">
          <h1 className="text-6xl md:text-8xl font-bold mb-6 text-white">
            NatSciX
          </h1>
          <p className="text-2xl md:text-3xl mb-2 text-green-300">IITs. NITs. AIIMS. Olympiads.</p>
          <p className="text-4xl md:text-6xl font-extrabold mb-10 text-white bg-navy px-6 py-3 rounded-lg inline-block shadow-lg">
            {currentHeroImage === 1 ? 'Only 80 Seats in India' : '₹ 1 Crore in Scholarships'}
          </p>
          
          <a
            href="https://natscix.com/exam/"
            className="btn-global text-xl mb-4"
          >
            Apply Now
          </a>
          
          <h2 className="text-3xl md:text-4xl mt-8 font-light">National Science Excellence Exam</h2>
        </div>
      </section>

      {/* Section 2: Features and Content */}
      <section id="about" className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="flex flex-col h-auto">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-10 mb-8 pb-6 border-b border-gray-200 bg-white rounded-xl p-6 shadow-sm text-left">
              {[
                { title: 'Science Camp', desc: '100% Sponsored', icon: iconScienceCamp },
                { title: 'Top Mentors', desc: 'IITians & Doctors', icon: iconTopMentors },
                { title: 'All-In-One Prep', desc: 'NEET | JEE | Olympiads', icon: iconAllInOnePrep },
                { title: '₹1 Cr Scholarships', desc: 'Tuition + Hostel Free', icon: iconOneCrScholarships }
              ].map((feature, index) => (
                <div key={index} className="flex flex-col items-center text-center">
                  <img
                    src={feature.icon}
                    alt={feature.title}
                    className="w-12 h-12 md:w-12 md:h-12 lg:w-14 lg:h-14 object-contain mb-2"
                    loading="lazy"
                    decoding="async"
                  />
                  <h3 className="font-alexandria text-base md:text-lg lg:text-xl font-bold text-gray-800">{feature.title}</h3>
                  <p className="text-xs md:text-sm text-gray-600 mt-1">{feature.desc}</p>
                </div>
              ))}
            </div>

            <div className="flex flex-col lg:flex-row">
              <div className="lg:w-1/2 w-full">
                <img 
                  src={feature1Image} 
                  alt="Science Camp" 
                  className="w-full h-full object-cover rounded-lg"
                  loading="lazy"
                  decoding="async"
                />
              </div>
              <div className="lg:w-1/2 w-full relative">
                <div 
                  className="absolute inset-0"
                  style={{
                    backgroundImage: `url(${aboutImage})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    filter: 'brightness(0.7)'
                  }}
                >
                  <div className="absolute inset-0 bg-navy-80"></div>
                </div>
                <div className="relative z-10 p-8 h-full flex flex-col justify-center text-white">
                  <h2 className="text-3xl font-bold mb-4">Change What You Believe About Yourself</h2>
                  <p className="text-xl mb-4 text-green-300">
                    For those ready to think beyond marks, and aim beyond limits.
                  </p>
                  <p className="text-lg mb-6">
                    NatSciX isn’t just about cracking exams it's about discovering if science truly moves you.
                  </p>
                  <p className="text-lg mb-8">
                    If you make it to the top 80, a fully sponsored 1-week camp will open doors to IITs, AIIMS, NITs, Olympiads, IISc, or global research.
                  </p>
                  <a
                    href="https://natscix.com/exam/"
                    className="inline-block btn-global btn-sm w-fit self-end"
                  >
                    Start Your NatSciX Journey
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section 3: What Makes This Camp Different */}
      <section id="journey" className="py-20 bg-cover bg-center relative">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage: `url(${journeyBgImage})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            filter: 'brightness(0.6)'
          }}
        >
          <div className="absolute inset-0 bg-navy-70"></div>
        </div>

        <div className="container mx-auto px-4 relative z-10">
          <div className="flex flex-col lg:flex-row items-start">
            <div className="lg:w-1/2 mb-10 lg:mb-0" style={{ textAlign: 'left' }}>
              <h1 className="text-6xl md:text-7xl font-bold text-white mb-4" style={{ textAlign: 'left', marginLeft: '0', marginRight: 'auto', display: 'block' }}>NatSciX</h1>
              <h2 className="text-5xl md:text-6xl font-bold text-green-400" style={{ textAlign: 'left', marginLeft: '0', marginRight: 'auto', display: 'block' }}>What Makes This Camp Different?</h2>
            </div>

            <div className="lg:w-1/2 text-white">
              <p className="text-xl font-bold text-green-300 mb-6">
                You won't be sitting in just another classroom. You'll be learning alongside 79 others just like you - driven, curious, and ready to push, support, and grow with you.
              </p>
              <p className="text-lg mb-4">
                For one full week, you'll be mentored by IITians, doctors, and Olympiad scholars who've already walked this path.
              </p>
              <p className="text-lg mb-4">
                They won't just train you. They'll challenge the way you think, solve, and see your future.
              </p>
              <p className="text-lg mb-8">
                This isn't a camp for toppers. It's for future scientists, innovators, and leaders.
              </p>
              <a
                href="https://natscix.com/exam/"
                className="inline-block btn-global"
              >
                Call to Know More
              </a>
            </div>
          </div>

          <div className="mt-16 grid grid-cols-1 md:grid-cols-4 gap-6">
            {[
              {
                title: "Nothing to Lose",
                desc: ["The exam is free.", "You only stand to grow."],
                icon: iconNothingToLose
              },
              {
                title: "Real Olympiad Exposure",
                desc: ["Experience national-level questions.", "No pressure. Just insight."],
                icon: iconRealOlympiadExposure
              },
              {
                title: "Confidence, Not Just Coaching",
                desc: ["Our camp builds mindset, grit, and belief", "not just marks."],
                icon: iconConfidenceNotJustCoaching
              },
              {
                title: "Your First Big Move",
                desc: ["Strategists start early.", "This is your edge."],
                icon: iconYourFirstBigMove
              }
            ].map((feature, index) => (
              <div key={index} className="bg-white bg-opacity-20 backdrop-blur-sm p-6 rounded-lg text-white text-center">
                <div className="flex items-center justify-center mb-3">
                  <img
                    src={feature.icon}
                    alt={feature.title}
                    className="w-8 h-8 md:w-10 md:h-10 object-contain mr-2"
                    loading="lazy"
                    decoding="async"
                  />
                  <h3 className="text-xl font-bold">{feature.title}</h3>
                </div>
                <div className="text-sm">
                  {feature.desc.map((line, idx) => (
                    <p key={idx} className="mb-1">{line}</p>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Section 4: News & Updates */}
      <section id="news" className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="flex flex-col lg:flex-row gap-8">
            <div className="lg:w-2/3">
              <div className="flex items-center justify-between mb-8">
                <h2 className="text-3xl font-bold">News & Updates</h2>
                <a href="#news" className="text-lg font-semibold text-green-600 hover:text-green-800">
                  Read All News
                </a>
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                {/* Featured Blog Post */}
                <div className="lg:col-span-1 cursor-pointer" onClick={() => navigateToBlog(blogPosts[0])}>
                  <img
                    src={blogPosts[0].image}
                    alt="Featured News"
                    className="w-full h-48 sm:h-56 md:h-64 object-cover rounded-lg mb-4 hover:opacity-90 transition-opacity"
                    loading="lazy"
                    decoding="async"
                  />
                  <p className="text-green-600 text-sm font-semibold mb-2">
                    {blogPosts[0].date} / {blogPosts[0].category}
                  </p>
                  <h3 className="text-xl font-bold text-gray-800 leading-tight hover:text-green-600 transition-colors">
                    {blogPosts[0].title}
                  </h3>
                  <p className="text-gray-600 mt-2 text-sm">{blogPosts[0].excerpt}</p>
                </div>

                {/* Other Blog Posts */}
                <div className="space-y-6">
                  {blogPosts.slice(1).map((post, index) => (
                    <div key={post.id} className="flex cursor-pointer hover:bg-gray-50 p-2 rounded-lg transition-colors" onClick={() => navigateToBlog(post)}>
                      <img
                        src={post.image}
                        alt={`News ${index + 1}`}
                        className="w-20 h-20 sm:w-24 sm:h-24 object-cover rounded mr-4 flex-shrink-0"
                        loading="lazy"
                        decoding="async"
                      />
                      <div>
                        <p className="text-green-600 text-sm font-semibold mb-1">
                          {post.date} / {post.category}
                        </p>
                        <h3 className="text-lg font-bold text-gray-800 leading-tight hover:text-green-600 transition-colors">
                          {post.title}
                        </h3>
                        <p className="text-gray-600 text-sm mt-1">{post.excerpt}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="lg:w-1/3">
              <div className="flex flex-col h-full min-h-[480px] md:min-h-[620px] overflow-hidden rounded-lg">
                {/* Upper Box 85% */}
                <div className="basis-[85%] bg-navy text-white p-6 rounded-t-lg">
                  <h2 className="text-2xl font-bold mb-6 flex items-center">
                    <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M12.586 4.586a2 2 0 112.828 2.828l-3 3a2 2 0 01-2.828 0 1 1 0 00-1.414 1.414 4 4 0 015.656 5.656l-3 3a4 4 0 01-5.656-5.656l3-3a4 4 0 015.656-5.656l-3-3z" clipRule="evenodd"/>
                    </svg>
                    Quick Links
                  </h2>
                  <ul className="space-y-4">
                  {[
                    "Exam Syllabus & Format",
                    "Important Dates",
                    "Eligibility Criteria",
                    "Sample Questions",
                    "Camp Overview",
                    "Scholarship Structure",
                    "About the Organisers",
                    "Past Student Stories"
                  ].map((link, index) => (
                    <li key={index}>
                      <a href="#knowledge-base" className="text-green-300 hover:text-green-100 transition-colors block py-1">
                        {link}
                      </a>
                    </li>
                  ))}
                  </ul>
                </div>
                {/* Lower Box 15% */}
                <div className="basis-[15%] p-5 rounded-b-lg bg-green-600 flex flex-col justify-center">
                  <h3 className="text-lg mb-1 text-white">Now that you know what's ahead</h3>
                  <p className="text-base mb-3 text-white/90">Are you ready to begin?</p>
                  <div className="flex items-center gap-3 justify-between w-full">
                    <a
                      href="https://natscix.com/exam/"
                      className="inline-block rounded-md px-4 py-2 text-sm w-fit shadow border border-gray-200"
                      style={{
                        color: '#0f172a',
                        background: 'linear-gradient(to right, #1d4ed8 5%, #ffffff 5%)'
                      }}
                    >
                      Start Your Registration
                    </a>
                    <span className="select-none font-alexandria font-extrabold text-white px-2 py-1 text-sm md:text-base lg:text-lg">NatSciX</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section 5: Knowledge Base */}
      <section id="knowledge-base" className="py-16">
        <div className="container mx-auto px-4">
          <div className="flex flex-col lg:flex-row gap-8 items-stretch">
            {/* Left Column: Static Image */}
            <div className="lg:w-1/3">
              <div className="h-full min-h-[280px] sm:min-h-[380px] md:min-h-[480px] bg-gray-200 rounded-lg overflow-hidden">
                <img
                  src={knowledgeBaseImage}
                  alt="Knowledge Base"
                  className="w-full h-full object-cover"
                  loading="lazy"
                  decoding="async"
                />
              </div>
            </div>

            {/* Right Column: Menu and Content */}
            <div className="lg:w-2/3 flex flex-col">
              {/* Menu Buttons */}
              <div className="flex flex-wrap gap-4 mb-8">
                {menus.map((menu, index) => (
                  <button
                    key={index}
                    onClick={() => setSelectedMenu(menu.title)}
                    className={`px-6 py-3 text-lg font-bold rounded-lg transition-colors ${
                      selectedMenu === menu.title
                        ? 'bg-green-500 text-white'
                        : 'bg-gray-200 text-gray-800 hover:bg-green-100 hover:text-green-700'
                    }`}
                  >
                    {menu.title}
                  </button>
                ))}
              </div>

              {/* Selected Content */}
              <div className="bg-white p-8 rounded-lg shadow-md flex-1">
                {menus.find((menu) => menu.title === selectedMenu)?.content}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="container mx-auto px-4">
          <div className="flex flex-col lg:flex-row justify-between items-center">
            <div className="mb-8 lg:mb-0">
              <h3 className="text-2xl font-bold mb-4">NatSciX</h3>
              <p className="text-gray-400 mb-4">National Science Excellence Exam</p>
              <div className="flex space-x-4">
                <a href="#home" className="text-gray-400 hover:text-white transition">
                  <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z"/>
                  </svg>
                </a>
                <a href="#home" className="text-gray-400 hover:text-white transition">
                  <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M22.46 6c-.77.35-1.6.58-2.46.69.88-.53 1.56-1.37 1.88-2.38-.83.5-1.75.85-2.72 1.05C18.37 4.5 17.26 4 16 4c-2.35 0-4.27 1.92-4.27 4.29 0 .34.04.67.11.98C8.28 9.09 5.11 7.38 3 4.79c-.37.63-.58 1.37-.58 2.15 0 1.49.75 2.81 1.91 3.56-.71 0-1.37-.2-1.95-.5v.03c0 2.08 1.48 3.82 3.44 4.21a4.22 4.22 0 0 1-1.93.07 4.28 4.28 0 0 0 4 2.98 8.521 8.521 0 0 1-5.33 1.84c-.34 0-.68-.02-1.02-.06C3.44 20.29 5.7 21 8.12 21 16 21 20.33 14.46 20.33 8.79c0-.19 0-.37-.01-.56.84-.6 1.56-1.36 2.14-2.23z"/>
                  </svg>
                </a>
                <a href="#home" className="text-gray-400 hover:text-white transition">
                  <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.226.792 24 1.771 24h20.451C23.2 24 24 23.226 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                  </svg>
                </a>
                <a href="#home" className="text-gray-400 hover:text-white transition">
                  <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12.017 0C5.396 0 .029 5.367.029 11.987c0 5.079 3.158 9.417 7.618 11.174-.105-.949-.199-2.403.041-3.439.219-.937 1.406-5.957 1.406-5.957s-.359-.72-.359-1.781c0-1.663.967-2.911 2.168-2.911 1.024 0 1.518.769 1.518 1.688 0 1.029-.653 2.567-.992 3.992-.285 1.193.6 2.165 1.775 2.165 2.128 0 3.768-2.245 3.768-5.487 0-2.861-2.063-4.869-5.008-4.869-3.41 0-5.409 2.562-5.409 5.199 0 1.033.394 2.143.889 2.741.099.118.112.226.085.345-.09.375-.293 1.199-.334 1.363-.053.225-.172.271-.402.16-.607-.28-1.033-.97-1.033-1.789 0-1.33 1.054-3.074 3.474-3.074 1.983 0 3.177 1.26 3.177 2.861 0 1.806-1.206 3.474-2.798 4.573-.559.375-.941.643-1.123.805-.402.375-.687.662-.687 1.155 0 .578.461.993 1.271.993 1.624 0 3.787-2.09 4.531-4.826.394-1.425.447-3.4.119-4.768z"/>
                  </svg>
                </a>
              </div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8">
              <div>
                <h4 className="text-lg mb-4">Quick Links</h4>
                <ul className="space-y-2">
                  <li><a href="#home" className="text-gray-400 hover:text-white transition">Home</a></li>
                  <li><a href="#about" className="text-gray-400 hover:text-white transition">About</a></li>
                  <li><a href="#journey" className="text-gray-400 hover:text-white transition">Academics</a></li>
                  <li><a href="#news" className="text-gray-400 hover:text-white transition">Blog</a></li>
                </ul>
              </div>
              <div>
                <h4 className="text-lg mb-4">Exam Info</h4>
                <ul className="space-y-2">
                  <li><a href="#knowledge-base" className="text-gray-400 hover:text-white transition">Exam Syllabus & Format</a></li>
                  <li><a href="#knowledge-base" className="text-gray-400 hover:text-white transition">Important Dates</a></li>
                  <li><a href="#knowledge-base" className="text-gray-400 hover:text-white transition">Eligibility Criteria</a></li>
                  <li><a href="#knowledge-base" className="text-gray-400 hover:text-white transition">Sample Questions</a></li>
                </ul>
              </div>
              <div>
                <h4 className="text-lg mb-4">Camp Info</h4>
                <ul className="space-y-2">
                  <li><a href="#journey" className="text-gray-400 hover:text-white transition">Camp Overview</a></li>
                  <li><a href="#journey" className="text-gray-400 hover:text-white transition">Scholarship Structure</a></li>
                  <li><a href="#journey" className="text-gray-400 hover:text-white transition">About the Organisers</a></li>
                  <li><a href="#journey" className="text-gray-400 hover:text-white transition">Past Student Stories</a></li>
                </ul>
              </div>
              <div>
                <h4 className="text-lg mb-4">Contact</h4>
                <ul className="space-y-2">
                  <li className="text-gray-400">7349494970</li>
                  <li className="text-gray-400">natscix@smis.edu.in</li>
                  <li><a href="https://natscix.com/exam/" className="text-green-400 hover:text-green-300 transition">Apply Now</a></li>
                </ul>
              </div>
            </div>
          </div>
          <div className="border-t border-gray-800 mt-8 pt-8 text-center">
            <p className="text-gray-400">&copy; 2025 NatSciX. All rights reserved.</p>
          </div>
        </div>
      </footer>

      {/* Blog Post Modal removed; blog opens via hash route now */}

      {/* Hidden Admin Panel Route */}
      {activeRoute?.type === 'admin' && (
        <AdminPanel
          blogPosts={blogPosts}
          setBlogPosts={setBlogPosts}
          onClose={() => { window.location.hash = ''; }}
        />
      )}
    </div>
  );
};

export default App;